export default function MurfreesboroTravelTimingSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">When to Apply</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Best Times to Apply in Murfreesboro
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Timing your application around MTSU academic calendars and Nashville travel seasons ensures smooth processing.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-[#F7F8FA] rounded-xl p-8 border-l-4 border-[#F6C344]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                <i className="ri-graduation-cap-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D]">Study Abroad Deadlines</h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              MTSU's study abroad application deadlines typically fall in October (spring semester) and March (fall semester). Apply for your passport at least 4-6 weeks before these deadlines to ensure you can complete your program application on time.
            </p>
            <div className="text-[#F6C344] text-sm font-semibold">
              <i className="ri-time-line mr-1"></i>
              Recommended: 6+ weeks before deadlines
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-xl p-8 border-l-4 border-[#1A365D]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D]">Business Travel</h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Nashville's music industry and healthcare sectors have peak conference seasons in spring (March-May) and fall (September-November). Murfreesboro professionals commuting to Nashville should apply 6-8 weeks before confirmed travel dates.
            </p>
            <div className="text-[#1A365D] text-sm font-semibold">
              <i className="ri-time-line mr-1"></i>
              Recommended: 6-8 weeks before travel
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-xl p-8 border-l-4 border-[#F6C344]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D]">Summer Vacation</h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Rutherford County families planning international summer vacations (June-August) should apply by March or April to avoid the summer passport rush. Family group applications can streamline the process.
            </p>
            <div className="text-[#F6C344] text-sm font-semibold">
              <i className="ri-time-line mr-1"></i>
              Recommended: 3-4 months before travel
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}